import { combineReducers } from "redux";
import { orgDetails } from './reducers/orgDetails';
import { userDetails } from './reducers/userDetails';
import { categoryList } from './reducers/categoryList';
import { language } from './reducers/language';
import { deviceList, deviceCount, deviceNextToken, deviceClearToken } from './reducers/deviceList';
import { cognitoUser } from './reducers/cognitoUser';
import { mainOrgData } from './reducers/mainOrgData';
import { roleList } from './reducers/roleList';
import { userList } from './reducers/userList';
import { groupList } from './reducers/groupList';
import { tempDepData } from './reducers/tempDepData';
import { apkContentList } from './reducers/apkContentList';
import { deployScheduler } from '../Containers/deployscheduler/reducer';
import { scheduler } from '../Containers/scheduler/reducer';
import { deployment } from '../Containers/deployment/reducer';
import { dashboard } from '../Containers/dashbaord/reducer';
import { plan, subscription } from '../Containers/subscription/reducer';
import { filterList } from './reducers/filterList';
import { searchedFilterList } from './reducers/searchedFilterList';
import { selectedFilter, clearSearchFilter } from './reducers/selectedFilter';
import { tempContent } from './reducers/tempContent';
import { tempGroup } from './reducers/tempGroup';
import { filterMenu } from './reducers/filterMenu';
import { deviceLoading } from './reducers/deviceLoading'
import { tempDeviceData } from './reducers/tempDeviceData'; // unused
import { deletedDevices } from './reducers/deletedDevices'; // unused
import { deletedGroup } from './reducers/deletedGroup';
import { selectedGroupData, clearSearchGroup, selectedTagData } from './reducers/selectedGroup'
import { getDeviceActions} from './reducers/getDeviceActions'
import { onlineDeviceList} from './reducers/onlineDeviceList'
import { filterCriteria, filterCriteriaApplied} from './reducers/filterCriteria'
import { hasMore} from './reducers/hasMore'
import { fromFilters} from './reducers/fromFilters' //unused
import { allContentList} from './reducers/allContentList'
import { devicesSelection } from './reducers/devicesSelection'
import { realtimeJob } from './reducers/realtimeJob'
import { portalFeatureSelection } from './reducers/portalFeatureSelection'
import { userInfo } from './reducers/userInfo'
import { deletedData } from './reducers/deletedData'



const appReducer = combineReducers({
    orgDetails,
    userDetails,
    realtimeJob,
    categoryList,
    language,
    deviceList,
    deviceCount,
    deviceNextToken,
    deviceClearToken,
    cognitoUser,
    roleList,
    mainOrgData,
    userList,
    groupList,
    tempDepData,
    apkContentList,
    deployScheduler,
    scheduler,
    deployment,
    dashboard,
    plan,
    subscription,
    filterList,
    searchedFilterList,// unused
    selectedFilter,
    tempContent,
    tempGroup,
    filterMenu,
    clearSearchFilter, // unused ??
    deviceLoading,
    tempDeviceData, // unused
    deletedDevices, // unused
    deletedGroup,
    selectedGroupData,
    clearSearchGroup,
    selectedTagData,
    getDeviceActions,
    onlineDeviceList,
    filterCriteria,
    filterCriteriaApplied, // unused ??
    hasMore,
    fromFilters,
    allContentList,
    devicesSelection,
    userInfo,
    portalFeatureSelection,
    deletedData
});

const rootReducer = (state: any, action: any) => {
    if (action.type === 'LOGOUT') {
        state = undefined;
    }
    return appReducer(state, action);
};

export default rootReducer;
